module.exports = __webpack_public_path__ + "img/location.acbd5a30.svg";